import { render } from "./familyGroup.vue?vue&type=template&id=5aa3ba3e&scoped=true"
import script from "./familyGroup.vue?vue&type=script&lang=js"
export * from "./familyGroup.vue?vue&type=script&lang=js"

import "./familyGroup.vue?vue&type=style&index=0&id=5aa3ba3e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa3ba3e"]])

export default __exports__